<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <input type="text" class="form-control" :id="safeId()" v-model.lazy="localValue"
             @focus="focused = true" @blur="focused = false">
    </div>
  </div>
</template>

<script>
export default {
  name: 'text-input-group',
  props: ['label', 'value'],
  data () {
    return {
      focused: false,
      localValue: this.value
    }
  },
  watch: {
    localValue: function (val) {
      this.$emit('input', val)
    },
    value: function (val) {
      if (!this.focused) {
        this.localValue = val
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/text-input-group.vue